import React, {useState} from "react";
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import UIUtils from "utils/UIUtils";
import StringUtil from 'utils/StringUtil';
import message from "common/message/source/MessageSource";
import KmcisLink, {KmcisConfirmResult} from "components/kmics";

function ContentsContainer() {
    const location = useLocation();
    const receivedData = (location.state as any)?.data;
    const history = useHistory();
    const [loginNm, setLoginNm] = useState('');
    const [userId, setUserId] = useState('');
	const [gubun, setGubun] = useState('0');

    let data = {};


	const tabClickHandler=(gubun:string)=>{
		setGubun(gubun);
	};


    const kmcisCallback = (result: KmcisConfirmResult, confirmed: boolean) => {
        console.log("KmcisConfirmResult", result)
        let hpNo = result?.phoneNo;

        if(hpNo != ""){
            getPersonInfo(hpNo);
        } else {
            UIUtils.alert("일치하는 회원 정보가 없습니다.");
        }

    }


    async function getPersonInfo(hpNo) {

        let param = {};

        if(gubun == '0') {

            param = { HPNO: hpNo,
                      GUBUN : gubun}

        } else if (gubun == '1') {

            if (loginNm == null || StringUtil.isEmpty(loginNm)) {
              UIUtils.alert(message.get("admin.appmanage.personmanage.pleaseInputId", "아이디를 입력해주세요")).then();
              return;
            }

            param = {HPNO: hpNo,
                     LOGIN_NM: loginNm,
                     GUBUN: gubun}

        }

        console.log(param);

        const response:any = await CommonUtil.execute({
            url: "usr_1400.jct",
            data: param
        }).then((response:any) => {
            let GUBUN = gubun;
            let LOGIN_NM = response.LOGIN_NM;
            let USER_ID = response.USER_ID;

            if(LOGIN_NM == null || USER_ID == null){
                UIUtils.alert('존재하지 않는 아이디입니다.').then();
                return false;
            }

            let dataToSend = {GUBUN, LOGIN_NM, USER_ID};

            // 다른 페이지로 이동하면서 데이터 전달
            history.push({
            pathname: './usr_1402',
            state: {data: dataToSend}
            });

        })


        console.log(response);

    }

    const isChkValid = () => {

        if(loginNm == "") {
            UIUtils.alert('아이디를 입력해주세요').then();
            return false;
        }

        return true;

    }



    React.useEffect(() => {
        console.log(receivedData);
        console.log("gubun : " + gubun );
        if(receivedData != undefined){
            setGubun(receivedData.GUBUN);
        }

    }, [])//effect


	return (
		<PageContainer session={false}>
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">로그인</Link></li>
				</ul>
				<main className="fww-main find-idpw-main">
                    <div className="find-idpw">
                        <h1 className="tx tx-hd2">아이디/비밀번호 찾기</h1>
                        <ul className="tab-menu">
                            <li className={gubun=== '0' ? "active" : ""} onClick={()=>tabClickHandler('0')}><button type="button">아이디찾기</button></li>
                            <li className={gubun=== '1' ? "active" : ""} onClick={()=>tabClickHandler('1')}><button type="button">비밀번호찾기</button></li>
                        </ul>
                        <div className={ 'tab-cont' + (gubun === '0' ? ' active' : '') }>
                            <form name="" action="" method="">
                                <div className="sub-txt">
                                    본인 명의의 휴대폰으로 인증번호를 받은 후,<br/> 서비스를 이용하실 수 있습니다.
                                </div>
                                <KmcisLink size={`big`} className={`button-certify`}
                                           urlCodeType={`2`}
                                           callback={kmcisCallback}>
                                    휴대폰 인증하기
                                </KmcisLink>
                            </form>
                            <div className="information">
                                <h3>안내</h3>
                                <ul className="list-group">
                                    <li>이용자의 개인정보 보호를 위해 본인확인 절차가 필요합니다.</li>
                                    <li>정보통신망(2012.08.18 시행) 제23조 2(주민번호 사용제한) 규정에 따라 온라인 상 주민번호의 수집/이용을 제한합니다.</li>
                                    <li>입력하신 정보는 본인확인 용도 외 사용되거나 저장되지 않습니다.</li>
                                </ul>
                            </div>
                        </div>
                        <div className={ 'tab-cont' + (gubun=== '1' ? ' active' : '') }>
                            <form name="" action="" method="">
                                <div className="find-pw">
                                    <div className="form-items mb15">
                                        <label className="mb15">아이디</label>
                                        <UIInput className={'tf tf-big w100p'} value={loginNm} placeholder={'아이디를 입력하세요'} valueChanged={(value) => setLoginNm(value)} />
                                    </div>
                                    <div className="hz-root hz-center">
                                        <KmcisLink color={'gray-o'} size={`big`} className={`bt`}
                                                   urlCodeType={`2`}
                                                   preCheck={isChkValid}
                                                   callback={kmcisCallback}>
                                            휴대폰 인증하기
                                        </KmcisLink>
                                    </div>

                                    <div className="sub-txt">
                                        본인 명의의 휴대폰으로 인증번호를 받은 후,<br/> 서비스를 이용하실 수 있습니다.
                                    </div>
                                </div>
                            </form>
                            <div className="information">
                                <h3>안내</h3>
                                <ul className="list-group">
                                    <li>이용자의 개인정보 보호를 위해 본인확인 절차가 필요합니다.</li>
                                    <li>정보통신망(2012.08.18 시행) 제23조 2(주민번호 사용제한) 규정에 따라 온라인 상 주민번호의 수집/이용을 제한합니다.</li>
                                    <li>입력하신 정보는 본인확인 용도 외 사용되거나 저장되지 않습니다.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </main>
			</div>			
		</PageContainer>
	);
}
export default ContentsContainer;